import { connect } from 'react-redux';

import ZoomView from './ZoomView.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

import { fetchIntegrations, getIntegrationForType } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount, updateZoomRecordingToggle } from 'src/legacy/redux/actions/integrations/zoomIntegration.jsx';
import _ from 'lodash';


const mapStateToProps = (state, ownProps) => {
    let integration = getIntegrationForType(state, 'zoom');
    return {
        user: state.users.me,
        integration: integration,
        integrations: state.legacyRootReducer.settings.integrations,
        activating: state.legacyRootReducer.settings.integrations.zoom.activating,
        deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
        error: state.legacyRootReducer.settings.integrations.zoom.error,
        enabled: state.legacyRootReducer.settings.integrations.zoom.recordingEnabled.enabled,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        authenticateAccount: (code, type) => {
            return dispatch(authenticateAccount(code, type));
        },

        fetchIntegrations: () => {
            return dispatch(fetchIntegrations());
        },
        updateZoomRecordingToggle: (enabled) => {
            return dispatch(updateZoomRecordingToggle(enabled));
        }
    }
}

const ZoomPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ZoomView);

export default withUseHooks(ZoomPage);
